import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/oreetiene/public_html/components/othersPages/Wishlist.jsx");
